import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { KeyEventUtil } from 'utils'

const GlosaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('inputDate-fechaDocumento', e, {
      preventDefault: false
    })
  }, [])

  return (
    <Form.Group>
      <Form.Label text='GLOSA' htmlFor='inputselect-glosa' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='glosa'>
          {({ field }) => (
            <Form.InputText
              {...field}
              id='input-glosa'
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(GlosaFormGroup)
